/** "Chiedi a mia Tina": sempre disponibile, sotto le azioni, con l'aspetto di un link. */
export type AskAgentLinkProps = {
  label: string
  onAsk?: () => void
}

export function AskAgentLink({ label, onAsk }: AskAgentLinkProps) {
  return (
    <button
      type="button"
      onClick={onAsk}
      className="mx-auto mt-4 block min-h-touch px-2 text-center text-meta text-ink underline underline-offset-4"
    >
      {label}
    </button>
  )
}
